import { Box, Typography } from "@mui/material"

export type KeyValueProps = { caption: string; value: string }
const KeyValue = ({ caption, value }: KeyValueProps) => {
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'space-between'
        }}>
            <Typography /* sx={{width: '50%'}} */ variant="text" fontWeight='500'>{caption}</Typography>

            <Typography /* sx={{width: '50%'}} */ variant="text" fontWeight='bold'>{value}</Typography>
        </Box>
    )
}

export { KeyValue }